import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import validator from 'validator';
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import DropDown from '../../Component/DropDown/DropDown';
import Input from '../../Component/Input/Input';
import { Radio } from '../../Component/Radio/Radio';
import ModalSkeleton from '../ModalSkeleton';
import classes from './ReportListingModal.module.css';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { BaseURL, apiHeader } from '../../config/apiUrl';
import { preferredMethodOptions } from '../../constant/commonData';

const ReportListingModal = ({ show, setShow, entity }) => {
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { accessToken } = useSelector((state) => state.authReducer);
  const { reportReasons } = useSelector((state) => state.commonReducer);
  const { t } = useTranslation('webCommon');
  const [reason, setReason] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [contactMethod, setContactMethod] = useState('Email');
  const [isLoading, setIsLoading] = useState(false);
  const handleSend = async () => {
    const url = BaseURL('report');
    const params = {
      reason: reason?._id,
      name,
      email,
      phoneNumber: phone,
      preferredContactMethod: contactMethod,
      entity
    };
    for (let key in params) {
      if (params[key] == '' || params[key] == null) {
        return toast.error(t('reportListingModal.toast.error', { key: key }));
      }
    }
    if (!validator.isEmail(email)) {
      return toast.error(t('reportListingModal.toast.validError'));
    }
    setIsLoading(true);
    const response = await Post(url, params, apiHeader(accessToken));
    if (response !== undefined) {
      // close the modal
      setShow(false);
      toast.success(t('reportListingModal.toast.success'));
    }
    setIsLoading(false);
  };
  return (
    <ModalSkeleton
      width={'650px'}
      show={show}
      setShow={setShow}
      header={t('reportListingModal.title')}
      headerClass={classes.header}>
      <style>{`.DropdownOptionContainer{
          text-transform:none;
        }`}</style>
      <Row className={classes.gap}>
        <Col md={12}>
          <DropDown
            options={reportReasons}
            value={reason}
            setValue={setReason}
            placeholder={t('reportListingModal.reasonPlaceholder')}
            customStyle={{
              width: '100%'
            }}
            getOptionLabel={(op) => op?.name?.[selectedLanguage]}
            optionValue={'_id'}
          />
        </Col>
        <Col md={6}>
          <Input
            inputStyle={{
              borderRadius: '5px'
            }}
            value={name}
            setValue={setName}
            placeholder={t('reportListingModal.namePlaceholder')}
          />
        </Col>
        <Col md={6}>
          <Input
            value={email}
            setValue={setEmail}
            inputStyle={{
              borderRadius: '5px'
            }}
            placeholder={t('reportListingModal.emailPlaceholder')}
          />
        </Col>

        <Col md={6}>
          <CustomPhoneInput
            value={phone}
            setter={setPhone}
            placeholder={t('reportListingModal.phonePlaceholder')}
          />
        </Col>
        <Col md={6} className={classes.contactWrap}>
          <p>{t('reportListingModal.preferredMethod')}</p>
          <div className={classes.methodWrap}>
            <Radio
              value={contactMethod}
              setValue={setContactMethod}
              label={preferredMethodOptions[0]?.[selectedLanguage]}
            />
            <Radio
              value={contactMethod}
              setValue={setContactMethod}
              label={preferredMethodOptions[1]?.[selectedLanguage]}
            />
            <Radio
              value={contactMethod}
              setValue={setContactMethod}
              label={preferredMethodOptions[2]?.[selectedLanguage]}
            />
          </div>
        </Col>
      </Row>

      <Button
        className={classes.btn}
        onClick={handleSend}
        label={isLoading ? t('reportListingModal.btnTextLoading') : t('reportListingModal.btnText')}
      />
      {/* <div className={classes.footer}>
        <p>Don’t have a free account yet? </p>
        <p>Create your free account now</p>
      </div> */}
    </ModalSkeleton>
  );
};

export default ReportListingModal;
